module.exports = __webpack_public_path__ + "static/media/item_37_3.dfe6c4a9.png";